import * as wjcCore from "@grapecity/wijmo"

/**
 * 空文字判定
 * @param value
 * @returns undefinedかnullかスペースのみ
 */
const isNullOrWhiteSpace = (value: string | null | undefined): boolean => {
  if (value == null) return true
  return wjcCore.isNullOrWhiteSpace(value)
}

/**
 * 空白除去文字列検索
 * @param target
 * @param checkString
 * @returns
 */
const compareWithoutWhiteSpace = (
  target: string | null | undefined,
  checkString: string | null | undefined
): boolean => {
  if (target == null && checkString == null) return true
  if (target == null || checkString == null) return false

  return (
    target.replaceAll(" ", "").replaceAll("　", "") ===
    checkString.replaceAll(" ", "").replaceAll("　", "")
  )
}

const stringUtil = {
  isNullOrWhiteSpace,
  compareWithoutWhiteSpace,
}

export default stringUtil
